import { useRuntimeConfig } from '#app'

export interface UnityInstance {
  SendMessage(objectName: string, methodName: string, value: string | number | boolean): void
  Quit(): Promise<void>
}
export interface UnityConfig {
  arguments: any[]
  dataUrl: string
  frameworkUrl: string
  codeUrl: string
  streamingAssetsUrl: string
  companyName: string
  productName: string
  productVersion: string
  showBanner: (msg: any, type: any) => void
  cacheControl: (url: string) => void
}

export interface UnityMessage {
  id: number
  time_stamp: string
  msg: any
}

declare function createUnityInstance(
  canvas: HTMLCanvasElement,
  config: UnityConfig,
  onProgress?: (progress: number) => void,
): Promise<UnityInstance>

export default async (canvas: HTMLCanvasElement): Promise<UnityInstance> => {
  const env = useRuntimeConfig()
  const UNITY_BUILD_URL = `${env.public.UNITY_BUILD_BASE_URL}/${env.public.UNITY_BUILD_VERSION}`
  function unityShowBanner(msg: any, type: any) {
    console.log('showBanner', msg, type)
  }

  const config = {
    arguments: [],
    dataUrl: `${UNITY_BUILD_URL}/build.data`,
    frameworkUrl: `${UNITY_BUILD_URL}/build.framework.js`,
    codeUrl: `${UNITY_BUILD_URL}/build.wasm`,
    streamingAssetsUrl: 'StreamingAssets',
    companyName: 'VRIFY',
    productName: '3D viewer',
    productVersion: '0.1.0',
    showBanner: unityShowBanner,
    cacheControl: function (url: string) {
      // Caching enabled for .data and .bundle files.
      // Revalidate if file is up to date before loading from cache
      if (url.match(/\.data/) || url.match(/\.bundle/)) {
        return 'must-revalidate'
      }

      if (url.match(/mapbox.*\.png/)) {
        return 'immutable'
      }
      // Disable explicit caching for all other files.
      // Note: the default browser cache may cache them anyway.
      return 'no-store'
    },
  }

  if ('createUnityInstance' in window) {
    return await createUnityInstance(canvas, config)
  }

  const script = document.createElement('script')
  script.src = `${UNITY_BUILD_URL}/build.loader.js`

  return new Promise((resolve, reject) => {
    script.onload = async () => {
      const instance = await createUnityInstance(canvas, config)
      resolve(instance)
    }
    script.onerror = reject
    document.body.appendChild(script)
  })
}
